import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';
import _get from 'lodash/get';

const NavBar = ({ className }) => {
    const navs = window.cccisd?.appDefs?.navs || [];
    const primaryNav = navs.find(nav => nav.handle === 'header');

    // careCoordinator tabs access
    const role = window.cccisd.fortress.user.acting.role.handle;
    if (navs && role === 'careCoordinator') {
        const { administerPageAccess, dashboardPageAccess, managePageAccess } =
            window.cccisd.fortress.user.acting.role_data;

        let revisedPrimaryNavTabs = primaryNav.nav;

        if (administerPageAccess !== null && dashboardPageAccess !== null && managePageAccess !== null) {
            if (!administerPageAccess) {
                revisedPrimaryNavTabs = revisedPrimaryNavTabs.filter(tab => tab.label !== 'Administer');
                primaryNav.homepage = 'dashboard';
            }
            if (!dashboardPageAccess) {
                revisedPrimaryNavTabs = revisedPrimaryNavTabs.filter(tab => tab.label !== 'Dashboard');
                primaryNav.homepage = 'manage';
            }
            if (!managePageAccess) {
                revisedPrimaryNavTabs = revisedPrimaryNavTabs.filter(tab => tab.label !== 'Manage');
                primaryNav.homepage = 'administer';
            }

            navs.find(nav => nav.handle === 'mainNav').homepage = _get(
                revisedPrimaryNavTabs,
                '[0].url',
                'administer'
            ).replace('/', '');
            primaryNav.nav = revisedPrimaryNavTabs;
        }
    }

    return (
        <Header
            containerClassName={className}
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            showAlertAction={false}
            showHomeAction={false}
            primaryNavLinks={primaryNav?.nav || []}
            isDarkPrimaryNav
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
